import { ReactNode } from 'react';
import { Box } from '@mui/material';

import { useStyles } from './styles';

const InfoBox = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();

  return <Box sx={classes.root}>{children}</Box>;
};

export default InfoBox;
